/** @jsxImportSource @emotion/react */
import React from 'react'
import { BannerForm, BannerPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/BannerContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageBanners } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageBanners]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <BannerForm />
        </div>
        <div css={styles.right}>
          <BannerPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
